import { ajaxGet, httpActions } from '@figure/frontlib-onboarding-redux';

const { baseUrl } = httpActions;

export const GET_CROSS_SELL_OFFER_PACKAGES = 'PL::GET_CROSS_SELL_OFFER_PACKAGES';

const SECURE = `${baseUrl()}/service-application-pl/secure/api/v1`;

export const getCrossSellOfferPackages = (uuid, showSpinner = true) => async (dispatch) =>
  ajaxGet(GET_CROSS_SELL_OFFER_PACKAGES, dispatch, `${SECURE}/application/offers/cross-sell/${uuid}`, null, null, showSpinner);
